//=require ../../../node_modules/jquery-mask-plugin/dist/jquery.mask.min.js

$('.cpf').mask('000.000.000-00', {reverse: true});
$('.cnpj').mask('00.000.000/0000-00', {reverse: true});
$('.telefone').mask("(00)00000-0000");
$('.cep').mask("00000-000");
$('.data').mask('00/00/0000');
$('.dinheiro').mask("#.##0,00", {reverse: true});